import script from "./OrganizationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationSettings.vue?vue&type=style&index=0&id=60a138e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a138e3"]])

export default __exports__